"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasContextAdapter = void 0;
/**
 * @public
 * Canvas implementation of {@link IContextAdapter}.
 */
class CanvasContextAdapter {
    constructor(canvasElement) {
        this.canvasElement = canvasElement;
        this.context = null;
    }
    onResize() {
        // no action needed
    }
    getContext() {
        if (this.context != null) {
            return this.context;
        }
        return this.context = this.canvasElement.getContext("2d");
    }
}
exports.CanvasContextAdapter = CanvasContextAdapter;
//# sourceMappingURL=canvas-context-adapter.js.map